import React from "react"
import PropTypes from "prop-types"
import { useIntl } from "gatsby-plugin-intl"
import CountUpAnimation from "../../UI/CountUpAnimation"

import {
  Section,
  Container,
  Content,
  Description,
  Column,
  Heading,
} from "./styles"

const DataGrid = ({ backgroundColor, textColor, data }) => {
  const intl = useIntl()

  // Render data
  const renderCount = count => {
    if (count) {
      return <CountUpAnimation>{count}</CountUpAnimation>
    }
    return intl.formatMessage({ id: "conflict.data_unknown" })
  }

  return (
    <Section color={backgroundColor}>
      <Container>
        {data.map(({ id, value, text }) => (
          <Column key={id}>
            <Content color={textColor}>
              <Heading>{renderCount(value)}</Heading>
              <Description>{text}</Description>
            </Content>
          </Column>
        ))}
      </Container>
    </Section>
  )
}

DataGrid.propTypes = {
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  data: PropTypes.array,
}

export default DataGrid
